import { createAsyncThunk } from '@reduxjs/toolkit';

export const setIsOpenedWalletModal = createAsyncThunk(
  'setIsOpenedWalletModal',
  (data: boolean): boolean => {
    return data;
  },
);
